module.exports = __webpack_public_path__ + "img/1 (2).56497f20.jpg";